/**
 * @description Internet Protocols
 */
export enum Protocol {
	HTTP = 'http',
	HTTPS = 'https',
	FTP = 'ftp'
}